import * as React from "react";
import { action } from "mobx";
import { observer } from "mobx-react";
import { PreviewStore } from "../Stores/PreviewStore";
import { Strings } from "../Stores/StringsStore";

export interface IViewListButtonProps {
	id?: string;
	disabled?: boolean;
	testId?: string;
	testName?: string;
	store: PreviewStore;
}

@observer
export class ViewList extends React.Component<IViewListButtonProps, {}> {

	@action onClick = () => {
		this.props.store.showPreviews = false;
	}

	render() {
		let className = this.props.store.showPreviews ? "button" : "button is--button-highlight";
		return <button id={this.props.id} className={className} disabled={this.props.disabled} onClick={this.onClick} data-test-id={this.props.testId} data-test-name={this.props.testName} title={Strings.reader.viewListButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<rect x="4" y="4" width="4" height="4" />
					<rect x="4" y="14" width="4" height="4" />
					<rect x="4" y="24" width="4" height="4" />
					<rect x="12" y="4" width="16" height="4" />
					<rect x="12" y="14" width="16" height="4" />
					<rect x="12" y="24" width="16" height="4" />
				</svg>
			</i>
		</button>;
	}
}
